import { render, staticRenderFns } from "./PendingDeclined.vue?vue&type=template&id=35acaffe"
import script from "./PendingDeclined.vue?vue&type=script&lang=js"
export * from "./PendingDeclined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports